module.exports = __webpack_public_path__ + "img/74-4c3305.png";